import { dateUtils } from './utils';

const DEFAULT_CONFIG = {
  allDaySlot: false,
  contextMenu: {
    enabled: true,
    items: [],
    render: null,
    onEvents: true,
    onCells: false,
  },
  calendarContainerClass: '',
  dayHeaderAlign: 'start',
  dayMinWidth: 200,
  editable: true,
  events: [],
  eventCreateEnabled: true,
  eventDeleteEnabled: true,
  eventDurationEditable: true,
  eventEditor: {
    render: null,
  },
  eventMinHeight: 0,
  eventResizableFromStart: true,
  eventShortHeight: 0,
  eventStartEditable: true,
  eventUpdateEnabled: true,
  firstDay: 1,
  header: {
    left: undefined,
    center: undefined,
    right: undefined,
  },
  height: '100%',
  initialView: 'timeGridScrollWeek',
  isBroadcastClock: false,
  isLoading: false,
  scheduleDateRange: {
    start: new Date(),
    end: dateUtils.addDays(new Date(), 7),
  },
  scrollTime: '06:00:00',
  scrollTimeReset: false,
  selectable: true,
  settingsPanel: {
    extraItems: [],
  },
  slotDuration: '00:30:00',
  slotHeaderInterval: '01:00:00',
  slotEventOverlap: false,
  slotHeaderFormat: {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    omitZeroMinute: false,
    meridiem: 'uppercase',
  },
  slotMinHeight: 60,
  slotMinWidth: 60,
  timeZone: 'UTC',
  tooltip: 'on',
  views: {},
};

export default DEFAULT_CONFIG;
